import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import DashboardSkeleton from "../components/common/DashboardLoader";

// Used on routes where login, signup or forgot password is displayed
const RequireLogin = () => {
  const location = useLocation();
  const isUserLoggedIn = localStorage.getItem("token");
  const userProfileData = useSelector((e) => e.profile.userProfile);

  const redirectTo =
    userProfileData?.type === "clinical_team"
      ? "/programs/questions"
      : "/home/dashboard";

  return (
    <div>
      {isUserLoggedIn ? (
        userProfileData?.type && userProfileData.type !== "super_admin" ? (
          <Navigate to={redirectTo} state={{ from: location }} replace />
        ) : (
          <Navigate to="/404/invalid_user_type" />
        )
      ) : (
        <Suspense fallback={<DashboardSkeleton loaderType="login" />}>
          <Outlet />
        </Suspense>
      )}
    </div>
  );
};

export default RequireLogin;
